module.exports = __webpack_public_path__ + "static/media/gl.47d7de15.svg";